export const CHECKOUT_SUCCESS_PATH = "/checkout/success";

const PADDLE_TRANSACTION_ID = /^txn_[a-z\d]{26}$/;

function normalizePath(pathname: string): string {
  return pathname.toLowerCase().replace(/\/+$/, "") || "/";
}

export function isCheckoutSuccessPath(pathname: string): boolean {
  return normalizePath(pathname) === CHECKOUT_SUCCESS_PATH;
}

export function checkoutSuccessUrl(transactionId: string, origin: string): string {
  if (!PADDLE_TRANSACTION_ID.test(transactionId)) {
    throw new Error("Paddle returned an invalid transaction ID.");
  }
  const url = new URL(CHECKOUT_SUCCESS_PATH, origin);
  url.searchParams.set("transaction_id", transactionId);
  return url.toString();
}

export function checkoutTransactionId(search: string): string | null {
  const transactionId = new URLSearchParams(search).get("transaction_id");
  return transactionId && PADDLE_TRANSACTION_ID.test(transactionId)
    ? transactionId
    : null;
}

export type OrderCompletionStatus =
  | "loading_session"
  | "sign_in"
  | "activating"
  | "delayed"
  | "active";

export function orderCompletionStatus(input: {
  authReady: boolean;
  authenticated: boolean;
  lifetimeActive: boolean;
  timedOut: boolean;
}): OrderCompletionStatus {
  if (!input.authReady) return "loading_session";
  if (!input.authenticated) return "sign_in";
  if (input.lifetimeActive) return "active";
  return input.timedOut ? "delayed" : "activating";
}

const HISTORY_KEY = "crimpOrderTransaction";
/** Keep the order reference in this history entry, never the Pixel page URL.
 * Repeated calls and reloads preserve the receipt/support experience. */
export function prepareOrderMeasurement(): string | null {
  if (!isCheckoutSuccessPath(window.location.pathname)) return null;
  const supplied = checkoutTransactionId(window.location.search);
  const remembered = window.history.state?.[HISTORY_KEY];
  const transactionId = supplied ?? (typeof remembered === "string" ? checkoutTransactionId(`transaction_id=${remembered}`) : null);
  if (supplied) {
    const url = new URL(window.location.href);
    url.searchParams.delete("transaction_id");
    try {
      window.history.replaceState({ ...window.history.state, [HISTORY_KEY]: supplied }, "", `${url.pathname}${url.search}${url.hash}`);
    } catch { /* Keep receipt UI working; the unchanged private URL blocks the Pixel. */ }
  }
  return transactionId;
}
